import React from "react";
import HeaderSearch from "./Layout/Search";
import Header from "./Layout/Default";
import renderPropsComposer from "utils/renderPropsComposer";

const Comp = ({ type = "", ...props }: any) => {
  return renderPropsComposer(
    {
      matcher: ({ type }: { type: string }) => type === "search",
      render: (props: any) => <HeaderSearch {...props} />,
    },
    {
      matcher: "default",
      render: () => <Header {...props} />,
    }
  )({ type, ...props });
};

export default Comp;
